import * as React from "react";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { CancelRegularCrystallisationAction } from "./Actions/CancelRegularCrystallisationAction";
import { GetRegularCrystallisationAction } from "./Actions/GetRegularCrystallisationAction";
import { CurrentSummary } from "./Components/CurrentSummary";
import { regularCrystallisationContent, successMessage } from "./Resource/Contents";
interface ICancelRegularCrystallisationWizardState extends IAccountContextWizardComponentState {
    extraInfo: any;
}
export class CancelRegularCrystallisationWizard extends AccountContextWizardComponent<
    ICancelRegularCrystallisationWizardState
> {
    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
            extraInfo: null,
        };
    }

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
        const params = getQueryParameters();
        const hierarchyId = params["hierarchyid"];
        GetRegularCrystallisationAction.getRegularCrystallisation(hierarchyId, (result) =>
            this.setState({ data: result })
        );
        this.setState({
            extraInfo: { showLightbox: false },
        });
    }

    setShowLightbox(show: boolean) {
        this.setState({ extraInfo: { ...this.state.extraInfo, showLightbox: show } });
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {
        const queryParams = getQueryParameters();
        const hierarchyId = queryParams["hierarchyid"];

        this.setState({ isSubmitting: true });
        CancelRegularCrystallisationAction.cancelRegularCrystallisation(hierarchyId, (result) => {
            if (result.length == 0) {
                this.setState({ active: false, isSubmitting: false });
                Navigator.navigateTo(toUrl, {
                    queryParamsObject: params,
                    scrollAfterNavigating: true,
                });
            }
        });
    }

    onCancel() {
        this.onExit();
    }

    onExit() {
        const params = getQueryParameters();
        //TODO: navigate to customer dashboard
        // Navigator.navigateTo(Urls.get().main.ClientDashboard, {
        //     queryParamsObject: {
        //         hierarchyid: params["hierarchyid"],
        //     },
        //     scrollAfterNavigating: true,
        // });
    }

    onSubmit() {
        this.setShowLightbox(false);
        this.onStepperLeave(0, 1);
    }

    setStepperConfig() {
        const { data, customer } = this.state;

        this.stepperConfig = [
            {
                title: regularCrystallisationContent.summaryTitle,
                url: Urls.get().CancelRegularCrystallisationReview,
                path: Contents.URLMap.review,
                type: StepType.Custom,
                component: (
                    <CurrentSummary
                        {...this.getStepProps(0)}
                        data={this.state.data}
                        showLightbox={this.state.extraInfo.showLightbox}
                        setShowLightbox={(show) => {
                            this.setShowLightbox(show);
                        }}
                        isActive={this.state.active}
                        isSubmitting={this.state.isSubmitting}
                        onConfirm={() => this.onSubmit()}
                    />
                ),
            },
            {
                title: regularCrystallisationContent.confirmationTitle,
                url: Urls.get().CancelRegularCrystallisationConfirmation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={successMessage(
                            customer?.PersonalDetails?.Name.Given,
                            customer?.PersonalDetails?.Name.Family
                        )}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }

    setProcessProps() {
        const { customer } = this.state;
        const processProps = super.setProcessProps();
        processProps.processTitle = "Cancel Regular Crystallisation";
        processProps.subTitle = "SIPP";
        processProps.onSave = null;
        processProps.needSplitHeader = {
            fromStep: 0,
            splitHeaderMain: `${customer?.PersonalDetails?.Name.Given} ${customer?.PersonalDetails?.Name.Family}`,
            splitHeaderSub: getQueryParameters()["claccountid"],
        };
        return processProps;
    }
}
